import { TableColumn } from '@/components/Table';
import { DataRow } from '.';

export const columns: TableColumn<DataRow>[] = [
  {
    name: 'Cód',
    cell: row => row.id,
    width: '280px',
  },
  {
    name: 'Setor e ingresso',
    selector: row => row.sectionAndTicket,
    minWidth: '160px',
  },
  {
    name: 'CPF',
    selector: row => row.cpf,
    minWidth: '130px',
    maxWidth: '130px',
  },
  {
    name: 'Status',
    cell: row => row.paymentStatus,
    minWidth: '150px',
  },
  {
    name: 'Ações',
    cell: row => row.actions,
    width: '210px',
  },
];
